module.exports = __webpack_public_path__ + "static/media/library.64aca98d.jpg";